export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// AI (see AI.md): the clinic front desk shares conversations instead of owning them, so the
// tabs are "AI handling", "Team" and "All" (replacing "Mine" and "Unassigned").
const SHARED_TAB_PERMISSIONS = [
  ...ROLES,
  MANAGE_ALL_CONVERSATION_PERMISSIONS,
  CONVERSATION_PARTICIPATING_PERMISSIONS,
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  ai: {
    count: 'aiCount',
    permissions: SHARED_TAB_PERMISSIONS,
  },
  team: {
    count: 'teamCount',
    permissions: SHARED_TAB_PERMISSIONS,
  },
  all: {
    count: 'allCount',
    permissions: SHARED_TAB_PERMISSIONS,
  },
};
